
import React from 'react'
import { createHashRouter, Navigate } from 'react-router-dom'
import useToken from '@/utils/useToken.js'

import pageLoader from '../layout/Loader.jsx'
import Layout from '../layout/index.jsx'
import Error404 from '../pages/Error/404.jsx'

const Signin = React.lazy(() => import('../pages/Auth/Signin.jsx'))
const Signup = React.lazy(() => import('../pages/Auth/Signup.jsx'))
const Dash = React.lazy(() => import('../pages/Dash/index.jsx'))
const Entries = React.lazy(() => import('../pages/Entries/index.jsx'))
const Finalists = React.lazy(() => import('../pages/Finalists/index.jsx'))
const Awards = React.lazy(() => import('../pages/Awards/index.jsx'))
const Advances = React.lazy(() => import('../pages/Advances/index.jsx'))
const ApplyReturn = React.lazy(() => import('../pages/WorkManage/applyReturn.jsx'))
const Members = React.lazy(() => import('../pages/Members/index.jsx'))
const Teachers = React.lazy(() => import('../pages/Teachers/index.jsx'))
const Deadline = React.lazy(() => import('../pages/Settings/deadline.jsx'))

const router = createHashRouter(
  [
    { path: '/auth/signin', Component: Signin, loader: pageLoader },
    { path: '/auth/signup', Component: Signup, loader: pageLoader },
    {
      path: '/', element: <AuthComponent><Layout /></AuthComponent>, loader: pageLoader, errorElement: <Error404 />, children: [
        { index: true, element: <Dash />, loader: pageLoader },
        { path: 'dash', element: <Dash />, loader: pageLoader },
        {
          path: 'entries', element: <Entries />, loader: pageLoader, children: [
            { index: true, element: <Entries />, loader: pageLoader },
            { path: 'list', element: <Entries />, loader: pageLoader }
          ]
        },
        {
          path: 'finalists', element: <Finalists />, loader: pageLoader, children: [
            { index: true, element: <Finalists />, loader: pageLoader },
            { path: 'list', element: <Finalists />, loader: pageLoader }
          ]
        },
        {
          path: 'awards', element: <Awards />, loader: pageLoader, children: [
            { index: true, element: <Awards />, loader: pageLoader },
            { path: 'list', element: <Awards />, loader: pageLoader }
          ]
        },
        {
          path: 'advances', element: <Advances />, loader: pageLoader, children: [
            { index: true, element: <Advances />, loader: pageLoader },
            { path: 'list', element: <Advances />, loader: pageLoader }
          ]
        },
        {
          path: 'applyReturn', element: <ApplyReturn />, loader: pageLoader, children: [
            { index: true, element: <ApplyReturn />, loader: pageLoader },
            { path: 'list', element: <ApplyReturn />, loader: pageLoader }
          ]
        },
        {
          path: 'members', element: <Members />, loader: pageLoader, children: [
            { index: true, element: <Members />, loader: pageLoader },
            { path: 'list', element: <Members />, loader: pageLoader }
          ]
        },
        {
          path: 'teachers', element: <Teachers />, loader: pageLoader, children: [
            { index: true, element: <Teachers />, loader: pageLoader },
            { path: 'list', element: <Teachers />, loader: pageLoader }
          ]
        },
        {
          path: 'settings', loader: pageLoader, children: [
            { path: 'deadline', element: <Deadline />, loader: pageLoader }
          ]
        }
      ]
    }
  ]
)

function AuthComponent({ children }) {
  const { getToken } = useToken()
  return getToken() ? children : <Navigate to={'/auth/signin'}></Navigate>
}

export default router